import { useFormContext } from 'react-hook-form';
import { Plus, ArrowRight, ArrowLeft } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

import { BrandFormData, PhaseProps } from '@/pages/settings/content/brands-sectors/create/shared/types';

export default function Three({ onNext, onBack }: PhaseProps) {
  const { watch, setValue, formState: { errors } } = useFormContext<BrandFormData>();
  
  const watchedData = watch();

  const handlePlatformChange = (index: number, field: 'link' | 'followers', value: string) => {
    const updatedPlatforms = [...(watchedData.platforms || [])];
    updatedPlatforms[index] = {
      ...updatedPlatforms[index],
      [field]: value
    };
    setValue('platforms', updatedPlatforms, { shouldValidate: true });
  };

  const addPlatform = () => {
    const currentPlatforms = watchedData.platforms || [];
    setValue('platforms', [
      ...currentPlatforms,
      { link: '', followers: '' }
    ], { shouldValidate: true });
  };

  const removePlatform = (index: number) => {
    const currentPlatforms = watchedData.platforms || [];
    const updatedPlatforms = currentPlatforms.filter((_, i) => i !== index);
    setValue('platforms', updatedPlatforms, { shouldValidate: true });
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Nova Marca</h2>
        <p className="text-gray-600">Adicione uma nova Marca ao Culture Monitor.</p>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Plataformas</h3>
          <p className="text-sm text-gray-600 mb-6">Preencha abaixo as plataformas da Marca.</p>
        </div>

        <div className="space-y-4">
          {(watchedData.platforms || []).map((platform, index) => (
            <div key={index} className="space-y-4 p-4 border border-gray-200 rounded-lg">
              <div className="flex justify-between items-center">
                <h4 className="text-sm font-medium text-gray-700">Plataforma {index + 1}</h4>
                {(watchedData.platforms || []).length > 1 && (
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => removePlatform(index)}
                    className="text-red-600 hover:text-red-700"
                  >
                    Remover
                  </Button>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Link</label>
                <Input
                  value={platform.link}
                  onChange={(e) => handlePlatformChange(index, 'link', e.target.value)}
                  placeholder="https://www.x.com/@nomedeusuario"
                  className={`w-full ${errors.platforms?.[index]?.link ? 'border-red-500' : ''}`}
                />
                {errors.platforms?.[index]?.link && (
                  <p className="text-red-500 text-xs mt-1">{errors.platforms[index]?.link?.message}</p>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Número de Seguidores</label>
                <Input
                  value={platform.followers}
                  onChange={(e) => handlePlatformChange(index, 'followers', e.target.value)}
                  placeholder="100"
                  className={`w-full ${errors.platforms?.[index]?.followers ? 'border-red-500' : ''}`}
                />
                {errors.platforms?.[index]?.followers && (
                  <p className="text-red-500 text-xs mt-1">{errors.platforms[index]?.followers?.message}</p>
                )}
              </div>
            </div>
          ))}

          {errors.platforms && typeof errors.platforms.message === 'string' && (
            <p className="text-red-500 text-xs mt-2">{errors.platforms.message}</p>
          )}
          
          <Button
            type="button"
            onClick={addPlatform}
            className="bg-gray-800 text-white hover:bg-gray-900 flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Adicionar
          </Button>
        </div>
      </div>

      <div className="flex justify-between">
        {onBack && (
          <Button
            type="button"
            variant="outline"
            onClick={onBack}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Button>
        )}
        
        <Button
          onClick={onNext}
          className="bg-gray-200 text-gray-800 hover:bg-gray-300 flex items-center gap-2 ml-auto"
        >
          Próximo
          <ArrowRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}